import { createSelector } from 'reselect';
import makeGetEventScoreboard from './make_get_event_scoreboard';

export default () => createSelector(
  makeGetEventScoreboard(),
  (score) => (score.overviewComments || []).find((comment) => comment.displayed),
);
